import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./toast.module.scss";

const TypeToast = [
    { title: "Sucesso", backgroundColor: "#5cb85c" },
    { title: "Error", backgroundColor: "#d9534f" },
    { title: "info", backgroundColor: "#5bc0de" },
    { title: "Atenção", backgroundColor: "#f0ad4e" },
];

export const newToast = (message, typeToast) => {
    const re = TypeToast.find((t) => t.title === typeToast);
    const id = Math.floor(Math.random() * 101 + 1);
    const design = { id: id, description: message };
    const leToast = { ...re, ...design };
    return leToast;
};
export const Toast = (props) => {
    const { toastList, position, autoDelete, autoDeleteTime } = props;
    const [list, setList] = useState(toastList);

    useEffect(() => {
        setList([...toastList]);

        // eslint-disable-next-line
    }, [toastList]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (autoDelete && toastList.length && list.length) {
                deleteToast(toastList[0].id);
            }
        }, autoDeleteTime);

        return () => {
            clearInterval(interval);
        };

        // eslint-disable-next-line
    }, [toastList, autoDelete, autoDeleteTime, list]);

    const deleteToast = (id) => {
        const listItemIndex = list.findIndex((e) => e.id === id);
        const toastListItem = toastList.findIndex((e) => e.id === id);
        list.splice(listItemIndex, 1);
        toastList.splice(toastListItem, 1);
        setList([...list]);
    };

    return (
        <>
            <div
                className={`${styles.notification_container} ${styles.bottom_left}`}
            >
                {list.map((toast, i) => (
                    <div
                        key={i}
                        className={`${styles.notification} ${styles.toast} ${styles.bottom_left}`}
                        style={{ backgroundColor: toast.backgroundColor }}
                    >
                        <button onClick={() => deleteToast(toast.id)}>X</button>
                        <div>
                            <p className={styles.notification_title}>
                                {toast.title}
                            </p>
                            <p className={styles.notification_message}>
                                {toast.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

Toast.propTypes = {
    toastList: PropTypes.array.isRequired,
    position: PropTypes.string,
    autoDelete: PropTypes.bool,
    autoDeleteTime: PropTypes.number,
};
